// src/components/DoctorBadge.jsx
import React from "react";

export default function DoctorBadge({ doctorName }) {
  const href = "https://lin.ee/bBukgUN";

  const getShortName = (name) => {
    if (!name) return "";

    const normalized = String(name).trim();

    // 李家豪醫師固定顯示「小李」
    if (normalized.includes("家豪")) {
      return "小李";
    }

    // 李啟鐘醫師固定顯示「李」
    if (normalized.includes("啟鐘")) {
      return "李";
    }

    // 若舊班表仍然存「小李醫師」
    if (normalized.includes("小李")) {
      return "小李";
    }

    // 其他醫師預設顯示第一個字
    return normalized.charAt(0);
  };

  const shortName = getShortName(doctorName);

  return (
    <a
      className="doctor-badge"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      aria-label={`${doctorName} 聯繫 LINE 官方帳號`}
      title="前往 LINE 官方帳號"
      data-label={shortName}
    >
      {doctorName}
    </a>
  );
}
